import { Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from '../../../../lib/ng2-sapmp/src/providers';
import { BreadCrumbModel, BreadCrumbService } from '../../../../lib/ng2-sapmp/src/ui-components/breadcrumb';
import { CareComponentService } from '..';
import { PageLoaderService } from '../../../../lib/ng2-sapmp/src/ui-components/page-loader';
import { deviceInventory } from 'config';
import { GridOptionsModel } from 'lib/ng2-sapmp/src/ui-components/custom-grid-extended';


@Component({
  selector: 'app-device-submission-tracking',
  templateUrl: './device-submission-tracking.component.html',
  styleUrls: ['./device-submission-tracking.component.scss'],
  providers: [CareComponentService]
})
export class DeviceSubmissionTrackingComponent implements OnInit {
  trackingData: any;
  querydropdowndata: any;
  columnDefs: any;
  rowData: any;
  imei: any;
  downloaddata: any;
  queryValue: any;
  selectedqueryvalue;
  transactionLogs: any;
  uiadminrecords: boolean= false;
  queryuirecords: boolean = true;
  duplicateError: boolean = false;
  expandLogs: boolean = false;
  gridOptions: GridOptionsModel;
  customGridOptions = new GridOptionsModel();
  trackingDataDetails: any = deviceInventory.trackingPageDetails;
  private gridApi;
  private gridColumnApi;
  queryString_: any;
  constructor(
    private breadcrumb: BreadCrumbService,
    private router: Router,
    private utilityService: UtilityService,
    private route: ActivatedRoute,
    private careService: CareComponentService,
    private pageloaderService: PageLoaderService
  ) { }

  ngOnInit(): void {
    console.log("Device Submission Tracking Component Initialized");
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    // this.pageloaderService.setPageLoaderStatus(false);
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.trackingData = this.route.snapshot.data.pageData.caredeviceSubmissionTracking;
    this.querydropdowndata = this.trackingData.queryvalues;
    console.log("querydropdowndata ::::::" + this.querydropdowndata.qdata[0].value);
    this.queryString_ = this.trackingData.queryString;
    this.pageLoad();
    this.columnDefs = this.trackingDataDetails.columnDefinitions;//this.trackingData.columnDefinitions;
    // this.columnDefs = this.columnDefs.map((colDef: any) => {
    //   if (colDef.headerName === 'Actions') {
    //     return {
    //       ...colDef,
    //       cellRenderer: (params: any) => {
    //         const button = document.createElement('button');
    //         button.innerHTML = '+';
    //         button.className = 'expand-button';
    //         button.addEventListener('click', () => {
    //           if (button.innerHTML === '+') {
    //             button.innerHTML = '-';
    //             this.imei = params.data._id;
    //             this.expandLogs = true;
    //             sessionStorage.setItem('IMEI', this.imei);
    //             this.fetchTransactionLogs(this.queryValue);
    //           } else {
    //             button.innerHTML = '+';
    //             this.expandLogs = false;
    //           }
    //         });
    //         return button;
    //       },
    //     };
    //   }
    //   return colDef;
    // });
    this.downloaddata = [];
    this.pageloaderService.setPageLoaderStatus(true);
    // this.trackingquerybtn(this.queryString_);
    // this.trackingdefauldropdown(this.trackingData.queryString);
    // this.pageLoad();
  }

  pageLoad() {
    const breadcrumb = new BreadCrumbModel();
    breadcrumb.label = this.trackingData.fanBreadcumb;
    breadcrumb.routerLink = this.trackingData.fanBreadcumb;
    this.breadcrumb.setCurrentBreadCrumb(breadcrumb);
  }

  autogrow() {
    let textArea = document.getElementById("description")
    textArea.style.overflow = 'hidden';
    textArea.style.height = 'auto';
    textArea.style.height = textArea.scrollHeight + 'px';
  }

  trackingquerybtn(selectedqueryvalue){
    this.pageloaderService.setPageLoaderStatus(false);
    this.downloaddata = [];
   console.log(selectedqueryvalue);
   this.uiadminrecords = false;
   this.queryuirecords = false;
   let querystring ={"queryString":selectedqueryvalue}
   this.queryValue = selectedqueryvalue;
   this.rowData = [];
   this.customGridOptions.gridData = [];
   this.gridOptions = null;
   this.careService.getTrackingData(querystring).subscribe(response => {
        this.queryuirecords = true;
        console.log(response);
        this.rowData = response;
        if(response === null){
          this.queryuirecords = false;
          this.uiadminrecords = true;
          var element = document.getElementById("scrollDIV");
          element.classList.remove("scrollbar");
        }else{
          this.rowData = this.rowData || [];

          this.customGridOptions.enableFiltering = true;
          this.customGridOptions.enableSorting = true;
          this.customGridOptions.multiSelect = true;
          const pagination = {
            recordsPerPage: 10,
            currentPage: 1,
            isServerSide: false,
            totalRecords: this.rowData.length,
            hideGoToPage: true,
          };
  
          this.rowData.map((x) => {
            x.isCollapsed = true;
          });
  
          this.customGridOptions.columnDefinitions = this.columnDefs;
          this.customGridOptions.maxLength = 15;
          this.customGridOptions.disableGrid = false;
          this.customGridOptions.disableRow = false;
          this.customGridOptions.Paginations = pagination;
          this.customGridOptions.gridData = this.rowData;
          this.gridOptions = this.customGridOptions;
        }
        this.pageloaderService.setPageLoaderStatus(true);
        
     }, error => {
        this.pageloaderService.setPageLoaderStatus(true);
        var element = document.getElementById("scrollDIV");
        element.classList.remove("scrollbar");
        this.duplicateError = true;
        setTimeout(function () {
            var element = document.getElementById("error-container");
              element.classList.remove("container-box");
        }, 1);
     });


 }


 fetchTransactionLogs(row) {
  this.pageloaderService.setPageLoaderStatus(false);
  this.transactionLogs = [];
  //let querystring ={"queryString":"[{$match:{\"_id\":\"${row}\"}}]", "imei":row};
  let querystring = {
    "queryString": `[{$match:{"_id":"${row}"}}]`
  };
  this.careService.getTransactionLogs(querystring, row).subscribe(
    (response) => {
      console.log('Transaction Logs:', response);
      this.transactionLogs = response;
      this.pageloaderService.setPageLoaderStatus(true);
      // alert("Transaction logs fetched successfully! : response" + JSON.stringify(response));
    },
    (error) => {
      this.pageloaderService.setPageLoaderStatus(true);
      console.error('Error fetching transaction logs:', error);
    }
  );
}

  trackingdefauldropdown(selectedqueryvalue){
    this.downloaddata = [];
   
   console.log(selectedqueryvalue);
   this.uiadminrecords = false;
   this.queryuirecords = false;
   var date = new Date();
   console.log(date);
   var curtdate = new Date(date.setHours(date.getHours()-24));
   console.log(curtdate);
   let intervaldate = this.careService.convertDate(curtdate);
   console.log(intervaldate);
   const regex = /date/gi;
   console.log(selectedqueryvalue.replace(regex, intervaldate));
   let querystring ={"queryString":selectedqueryvalue.replace(regex, intervaldate)}
   this.careService.getTrackingData(querystring).subscribe(response => {
       this.queryuirecords = true;
       console.log(response);
       this.rowData = response;
       if(response === null){
         this.queryuirecords = false;
         this.uiadminrecords = true;
         var element = document.getElementById("scrollDIV");
         element.classList.remove("scrollbar");
       }
       this.pageloaderService.setPageLoaderStatus(true);
     }, error => {
     var element = document.getElementById("scrollDIV");
      element.classList.remove("scrollbar");
      this.duplicateError = true;
      setTimeout(function () {
           var element = document.getElementById("error-container");
            element.classList.remove("container-box");
      }, 1);
     });
 }

 onGridReady(params) {
  this.gridApi = params.api;
  this.gridColumnApi = params.columnApi;
}

onSelectionChanged() {
  var selectedRows = this.gridApi.getSelectedRows();
  console.log(selectedRows);
  this.downloaddata = selectedRows;
}

downloadtrackingdata(){
  console.log(this.downloaddata);
  this.downloadFile(this.downloaddata, 'deviceSubmissionTrackingData');
  }

downloadFile(data: any, filename='data') {
  let mapped_data = data.map(item => ({
    model: item.model ? item.model.replace(/,/g, ' ') : "", // Remove commas from model
    manufacturer: item.manufacturer ? item.manufacturer.replace(/,/g, ' ') : "", // Remove commas from manufacturer
    createdAt: item.createdAt,
    lastUpdatedAt: item.lastUpdatedAt,
    eventType: item.eventType,  
    currentStatus: item.currentStatus,
    cdfStatus: item.cdfStatus,
    _id: item._id,
    subStatus: item.subStatus,
    enrollmentStatusReason: item.enrollmentStatusReason
  }));
  console.log("mapped data===>", mapped_data);
  let csvData = this.ConvertToCSV(mapped_data, ['_id','model', 'manufacturer', 'createdAt',
  'lastUpdatedAt','eventType','currentStatus','cdfStatus','subStatus','enrollmentStatusReason']);
  console.log(csvData);
  let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
  let dwldLink = document.createElement("a");
  let url = URL.createObjectURL(blob);
  let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
  if (isSafariBrowser) { //if Safari open in new window to save file with random filename.
  dwldLink.setAttribute("target", "_blank");
  }
  dwldLink.setAttribute("href", url);
  dwldLink.setAttribute("download", filename + ".csv");
  dwldLink.style.visibility = "hidden";
  document.body.appendChild(dwldLink);
  dwldLink.click();
  document.body.removeChild(dwldLink);
}

ConvertToCSV(objArray: string, headerList: string[]) {
  let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
  let str = '';
  let row = 'SNo,';

  for (let index in headerList) {
      row += headerList[index] + ',';
  }
  row = row.slice(0, -1);
  str += row + '\r\n';

  for (let i = 0; i < array.length; i++) {
      let line = (i+1)+'';
      for (let index in headerList) {
         let head = headerList[index];
         line += ',' + array[i][head];
      }
      str += line + '\r\n';

  }
  return str;
}

onRowClick(action) {
  
  if(action.type == 'singleselect'){
    let download_data = [...this.downloaddata]; // Clone the existing array
    const exists = download_data.some(item => item._id === action.data._id); // Check for duplicates based on _id

    if (!exists) {
      download_data.push(action.data); // Push only if the _id is not already present
    }else{
      download_data = download_data.filter(item => item._id !== action.data._id);
    }
    this.downloaddata = download_data;
  }else{
    if(this.downloaddata.length < action.griddata.length){
      this.downloaddata = action.data;
    }else{
      this.downloaddata = [];
    }
  }
  
}

}